import { render, staticRenderFns } from "./BestAthletesEventDashboard.vue?vue&type=template&id=1a1997f2&"
import script from "./BestAthletesEventDashboard.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesEventDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./BestAthletesEventDashboard.vue?vue&type=style&index=0&id=1a1997f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports